import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    fbq: any;
  }
}

const ScrollToTop = () => {
    const { pathname } = useLocation();
    const isFirstRun = useRef(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        // Fire Meta Pixel pageview on subsequent route changes
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'PageView');
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
